/**
 * @license
 * Copyright 2016 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Blockly constants.
 *
 * @namespace Blockly.constants
 */
import * as goog from '../closure/goog/goog.js';
goog.declareModuleId('Blockly.constants');


/**
 * The language-neutral ID given to the collapsed input.
 *
 * @alias Blockly.constants.COLLAPSED_INPUT_NAME
 */
export const COLLAPSED_INPUT_NAME = '_TEMP_COLLAPSED_INPUT';

/**
 * The language-neutral ID given to the collapsed field.
 *
 * @alias Blockly.constants.COLLAPSED_FIELD_NAME
 */
export const COLLAPSED_FIELD_NAME = '_TEMP_COLLAPSED_FIELD';
